var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "#e8eaed"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M320-200v-560l440 280-440 280Zm80-280Zm0 134 210-134-210-134v268Z"
})));
export default __webpack_public_path__ + "static/media/play_arrow.b48ac65b.svg";
export { SvgComponent as ReactComponent };